import Header from "../../../../../components/header";
import { FestivalSkeletonWhiteBox } from "../../style/skeleton";
import {
  FestivalEventInfoContent,
  FestivalEventInfoItem,
  FestivalEventInfoWrapper,
} from "./competitions/info/style";
import RabbitFestivalEventITM from "./competitions/itm";
import {
  FestivalEventLocationWrapper,
  FestivalEventLocationInfo,
  FestivalEventLocationText,
  FestivalEventLocationCopy,
} from "./competitions/location/style";
import RabbitFestivalEventNotice from "./competitions/notice";
import RabbitFestivalEventStructure from "./competitions/structure";
import { RabbitFestivalEventWrapper } from "./style";

const RabbitFestivalEventSkeleton = () => {
  const infoList = [
    { name: "상태" },
    { name: "토탈 프라이즈" },
    { name: "날짜" },
    { name: "시간" },
    { name: "바이인" },
    { name: "레지 마감" },
    { name: "스타팅 칩" },
    { name: "리엔트리 칩" },
    { name: "듀레이션" },
  ];

  return (
    <RabbitFestivalEventWrapper>
      <Header
        title="RABBIT FESTIVAL"
        show={true}
        img={`/image-web/news/share_white.svg`}
      />
      <FestivalSkeletonWhiteBox width="100%" height="324px" radius="0" />
      <FestivalEventInfoWrapper>
        <div className="title">GAME INFORMATION</div>
        <FestivalEventInfoContent>
          {infoList.map((item, index) => (
            <FestivalEventInfoItem key={index}>
              <div className="name">{item.name}</div>
              <FestivalSkeletonWhiteBox width="90px" height="15px" />
            </FestivalEventInfoItem>
          ))}
        </FestivalEventInfoContent>
      </FestivalEventInfoWrapper>
      <FestivalEventLocationWrapper>
        <div className="title">위치</div>
        <FestivalSkeletonWhiteBox width="100%" height="129px" radius="8px" />
        <FestivalEventLocationInfo>
          <FestivalEventLocationText>
            <FestivalSkeletonWhiteBox width="80px" height="17px" />
            <FestivalSkeletonWhiteBox width="150px" height="17px" />
          </FestivalEventLocationText>
          <FestivalEventLocationCopy>
            <img src="/image-web/rabbit/copy.png" alt="copy" />
          </FestivalEventLocationCopy>
        </FestivalEventLocationInfo>
      </FestivalEventLocationWrapper>
      <RabbitFestivalEventITM />
      <RabbitFestivalEventStructure />
      <RabbitFestivalEventNotice />
    </RabbitFestivalEventWrapper>
  );
};

export default RabbitFestivalEventSkeleton;
